export default "__VITE_ASSET__BEvo3LaV__"